const EARTH_RADIUS_KM = 6371;
const RAD = Math.PI / 180;

export const haversineKm = (a: { latitude: number; longitude: number }, b: { latitude: number; longitude: number }) => {
  const dLat = (b.latitude - a.latitude) * RAD;
  const dLon = (b.longitude - a.longitude) * RAD;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(a.latitude * RAD) * Math.cos(b.latitude * RAD) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
};

export const routeDistanceKm = (points: Array<{ latitude: number; longitude: number }>) =>
  points.reduce((total, p, i) => (i ? total + haversineKm(points[i - 1], p) : 0), 0);

/** Initial bearing from a to b in degrees, clockwise from north. */
export const bearingDeg = (a: { latitude: number; longitude: number }, b: { latitude: number; longitude: number }) => {
  const y = Math.sin((b.longitude - a.longitude) * RAD) * Math.cos(b.latitude * RAD);
  const x =
    Math.cos(a.latitude * RAD) * Math.sin(b.latitude * RAD) -
    Math.sin(a.latitude * RAD) * Math.cos(b.latitude * RAD) * Math.cos((b.longitude - a.longitude) * RAD);
  return (Math.atan2(y, x) / RAD + 360) % 360;
};

export const bounds = (
  points: Array<{ latitude: number; longitude: number }>,
): [[number, number], [number, number]] => {
  let minLon = Infinity;
  let minLat = Infinity;
  let maxLon = -Infinity;
  let maxLat = -Infinity;
  for (const point of points) {
    minLon = Math.min(minLon, point.longitude);
    minLat = Math.min(minLat, point.latitude);
    maxLon = Math.max(maxLon, point.longitude);
    maxLat = Math.max(maxLat, point.latitude);
  }
  return [
    [minLon, minLat],
    [maxLon, maxLat],
  ];
};
